import React from 'react';
import {Award, BadgeCheck, BriefcaseBusiness, Users} from 'lucide-react';

const credentials=[
  {icon:Award,value:'20+ Years',label:'Licensed CPA experience'},
  {icon:BadgeCheck,value:'Tax Strategy',label:'Deep consulting expertise'},
  {icon:BriefcaseBusiness,value:'Year-Round Planning',label:'Quarterly projections and estimates'},
  {icon:Users,value:'Founder-Led',label:'Personal, accountable service'}
];

const CredibilityBar=()=> <section className="px-3 md:px-6 pb-8 md:pb-12" aria-label="AJ Tax Consulting credentials">
  <div className="max-w-7xl mx-auto bg-white border border-[#071a36]/10 rounded-2xl shadow-sm">
    <div className="grid sm:grid-cols-2 lg:grid-cols-4">
      {credentials.map(({icon:Icon,value,label},index)=><div key={value} className={`flex items-center gap-4 px-6 py-5 md:py-6 ${index?'border-t sm:border-t-0 sm:border-l border-[#071a36]/10':''} ${index===2?'sm:border-t lg:border-t-0':''}`}>
        <span className="w-11 h-11 shrink-0 rounded-xl bg-[#dceeff] text-[#071a36] flex items-center justify-center"><Icon size={20}/></span>
        <div><p className="font-semibold text-[#071a36] leading-tight">{value}</p><p className="text-xs text-[#52647a] mt-1 leading-snug">{label}</p></div>
      </div>)}
    </div>
  </div>
</section>;

export default CredibilityBar;
